import React from 'react';
import { Sections } from 'features/page-navigation/components/section-refs-context';
import { getComplements } from 'features/related-products/selectors';
import { cn } from 'utils';
import { Styles } from 'pages/product-details/styles';
import { AntifadeContainer } from 'common/components/section-vlimit/fade-container/fade-container';
import { pdpSectionStyle } from 'common/components/page-section';
import { useTranslation } from 'react-i18next';
import { withStoreLogic } from '../hocs/with-store-logic';
import { RecommendedGoods } from '../recommendations';

type ComplementGoodsMappedState = {
  products?: string[];
};

type ComplementGoodsProps = ComplementGoodsMappedState &
  React.HTMLAttributes<HTMLElement> & {
    id: string;
    placementId: string;
    productId: string;
    withDivider?: boolean;
    _abTestName?: string;
  };

export const ComplementGoodsWithReco: React.FC<ComplementGoodsProps> = ({
  placementId,
  productId,
  products = [],
  withDivider = false,
  className,
  id,
  _abTestName,
}) => {
  const ref = React.useContext(Sections.Context).get('complements') ?? undefined;
  const { t } = useTranslation();
  const title = t('sticky-panel.navigation-tabs.complements');
  return (
    <section
      ref={ref as React.Ref<HTMLDivElement>}
      className={cn(className, pdpSectionStyle)}
      id={id}
      data-qa={`recoblock-${id}`}
    >
      <AntifadeContainer />
      <div className={Styles.pdpSectionInsideInfoBlockStyle}>
        <RecommendedGoods
          title={title}
          pageType="productPlacements"
          id={id}
          placementId={placementId}
          productId={productId}
          elementBlock={id}
          withDivider={withDivider}
          _additionalProducts={products.map(Number)}
          _productsLimit={2}
          _abTestName={_abTestName}
        />
      </div>
    </section>
  );
};

export const PdpComplementGoodsWithReco = withStoreLogic(ComplementGoodsWithReco, getComplements);
